import type { NoteEventAction } from './loggerActions';
import type { LoggerDraft } from './loggerDraftTypes';

// Timeline note-event sub-reducer (Solution C). Owns the three note mutations
// so loggerNestedReducer stays under the 500-line budget — it delegates here
// via a single early-return guard. Pure; notes live on LoggerDraft.noteEvents
// (absent reads as []), entirely separate from entries[].sets[] so a note
// edit can never touch a logged set.
export function noteEventReducer(
  state: LoggerDraft,
  action: NoteEventAction,
): LoggerDraft {
  const events = state.noteEvents ?? [];
  switch (action.type) {
    case 'add_note_event':
      return { ...state, noteEvents: [...events, action.note] };
    case 'update_note_event':
      return {
        ...state,
        noteEvents: events.map((n) =>
          n.id === action.id ? { ...n, text: action.text } : n,
        ),
      };
    case 'remove_note_event':
      return {
        ...state,
        noteEvents: events.filter((n) => n.id !== action.id),
      };
  }
}
